export default import.meta.ROLLUP_FILE_URL_D3l0RV0$;